// User and Dropdown are not ordered "multiple-first" but in alphabetical order
// to prevent [mini-css-extract-plugin] Conflicting order. error:
// https://github.com/somia/ninchat-app/pull/253/commits/fbcf91360ab515c44217475bda50b39017927cf1
/* eslint-disable sort-imports */
import User from '../User'
import {
    Dropdown,
    DropdownButtonNew,
    DropdownContent,
} from '../Dropdown'
/* eslint-enable sort-imports */

import {
    channelMembers as channelMembersStyles, membersCountWrapper,
} from './styles'

import Button from 'components/Button'
import {ChannelMembersViewProps} from './types'
import React from 'react'
import UserInfo from '../UserInfo'


import {styled} from 'stitches/config'

type UserProps = {
    channelId?: string
    size?: 'small'
    userId: string
    arrangeInRow?: boolean
}

const StyledChannelMembers = styled('div', channelMembersStyles)
const StyledMembersCountWrapper = styled('div', membersCountWrapper)

const ChannelMemberView = ({
    channelId,
    size,
    userId,
    arrangeInRow,
}: UserProps): React.ReactElement => (
    <Dropdown>
        <DropdownButtonNew caret={false} color='text' css={{...arrangeInRow ? {} : {padding: '2px'}}}>
            <User avatarOnly={!arrangeInRow} size={size} userId={userId} />
        </DropdownButtonNew>
        <DropdownContent customClass='with-submenu' direction={arrangeInRow ? 'left' : 'right'}>
            <UserInfo channelId={channelId} light={true} size='mid' userId={userId} />
        </DropdownContent>
    </Dropdown>
)

const ChannelMembersView = ({
    channelId,
    channelMembers,
    arrangeInRow,
    hasMoreChannelMembers,
    channelMembersCount,
    openSidebar,
    size,
}: ChannelMembersViewProps): React.ReactElement => (
    <StyledChannelMembers arrangeInRow={arrangeInRow}>
        {
            !!channelMembers && channelMembers.map((channelMember) => (
                <ChannelMemberView
                    arrangeInRow={arrangeInRow}
                    channelId={channelId}
                    key={channelMember.userId}
                    size={size}
                    userId={channelMember.userId}
                />))
        }
        {/* eslint-disable-next-line no-extra-parens */}
        {(!arrangeInRow && !!hasMoreChannelMembers) ?
            <StyledMembersCountWrapper>
                <Button
                    color='text'
                    onPress={openSidebar}
                    text={`+${channelMembersCount}`}
                />
            </StyledMembersCountWrapper>
            : null}
    </StyledChannelMembers>
)

ChannelMemberView.defaultProps = {
    arrangeInRow: false,
    channelId: undefined,
    size: undefined,
}

const isEqual = (prevProps: ChannelMembersViewProps, nextProps: ChannelMembersViewProps) => {
    // check if the order is equal for channel members
    const areChannelMembersEqual = prevProps?.channelMembers?.every((member, index) => {
        const nextMember = nextProps?.channelMembers?.[index]
        return member?.userId === nextMember?.userId
    }) && prevProps?.channelMembers?.length === nextProps?.channelMembers?.length

    return areChannelMembersEqual && prevProps?.channelId === nextProps?.channelId &&
        prevProps?.arrangeInRow === nextProps?.arrangeInRow &&
        prevProps?.hasMoreChannelMembers === nextProps?.hasMoreChannelMembers &&
        prevProps?.channelMembersCount === nextProps?.channelMembersCount &&
        prevProps?.size === nextProps?.size
}
export default React.memo(ChannelMembersView, isEqual)
